import {
  ACTIONS,
  SHIPMENT_ORDER_CSV_IMPORT
} from '@/constants/common/message.constants'

import { SUNTORY_DEDICATED_IMPORT_TARGET_DC_CODE } from './constants'

/**
 * 得意先/拠点専用の配送依頼インポート機能の定義。
 * 配送依頼のインポートの入口（取り込み方法の画面）が、拠点ごとに出す選択肢の判定に使う。
 */
export type CustomShipmentOrderImport = {
  key: string
  label: string
  /** 配送依頼のインポートの最初の画面（取り込み方法）に出す説明。 */
  description: string
  canShow: (ctx: { tenantKey: string; dcCode: string | undefined }) => boolean
}

// サントリー様の取込（社内移動・得意先）を出す拠点。Dc.code はテナントスコープで unique 制約が無いため、
// 判定コンテキストに tenantKey を含めて一意にする
const isSuntoryTargetDc = ({
  tenantKey,
  dcCode
}: {
  tenantKey: string
  dcCode: string | undefined
}) =>
  tenantKey === 'konoike' && dcCode === SUNTORY_DEDICATED_IMPORT_TARGET_DC_CODE

export const CUSTOM_SHIPMENT_ORDER_IMPORTS: CustomShipmentOrderImport[] = [
  {
    key: 'suntory-internal',
    label: SHIPMENT_ORDER_CSV_IMPORT.METHOD_SUNTORY_INTERNAL_TITLE,
    description: SHIPMENT_ORDER_CSV_IMPORT.METHOD_SUNTORY_INTERNAL_DESCRIPTION,
    canShow: isSuntoryTargetDc
  },
  {
    key: 'suntory-dedicated',
    label: ACTIONS.IMPORT_SUNTORY_DEDICATED_SHIPMENT_ORDER,
    description: SHIPMENT_ORDER_CSV_IMPORT.METHOD_SUNTORY_DEDICATED_DESCRIPTION,
    canShow: isSuntoryTargetDc
  }
]
